import _objectSpread from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import api from '@/api';
import EditSex from '../assembly/editSex/index';
import EditBirthday from '../assembly/editBirthday/index';
import EditVaus from '../assembly/editVAu/index';
import SelectData from '../assembly/selectData/index';
import SelectMemberPushMessages from '../assembly/selectPushMessages/index';
import MemberFreezeRecords from '../../memberFreezeRecords/edit/index';
import MemberLink from '@/views/system/memberTourists/memberLink/index';
import { Message } from 'element-ui';
import util from '@/libs/util';
export default {
  components: {
    EditSex: EditSex,
    EditBirthday: EditBirthday,
    EditVaus: EditVaus,
    SelectData: SelectData,
    SelectMemberPushMessages: SelectMemberPushMessages,
    MemberFreezeRecords: MemberFreezeRecords,
    MemberLink: MemberLink
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MemberEdit',
  data: function data() {
    return {
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      fileList: [],
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isUpdateInfo1: this.checkauthority('update_sex_info'),
      isUpdateInfo2: this.checkauthority('update_bosdy_info'),
      isUpdateInfo3: this.checkauthority('add_v_auth_info'),
      isUpdateInfo4: this.checkauthority('update_push_message_info_list'),
      isUpdateInfo5: this.checkauthority('member_info_user_data'),
      isUpdateInfo6: this.checkauthority('member_info_tuijian'),
      isUpdateInfo7: this.checkauthority('member_info_dongjie'),
      isUpdateInfo8: this.checkauthority('member_info_yongjiu_dongjie'),
      isUpdateInfo9: this.checkauthority('member_del'),
      freezeRecordsDialogVisible: false,
      freezeRecordsDisabled: false,
      editMemberInfoDialogVisible: false,
      editMemberInfoDisabled: false,
      selectDataDialogVisible: false,
      selectDataDisabled: true,
      editVauDialogVisible: false,
      editVauDisabled: false,
      editBirthdayDialogVisible: false,
      editBirthdayDisabled: false,
      editSexDialogVisible: false,
      editSexDisabled: false,
      memberLinkDialogVisible: false,
      title: '',
      form: {
        memberId: null,
        nickName: '',
        sex: '',
        name: '',
        headUrl: '',
        phone: '',
        userName: '',
        passWord: '',
        wxMiniOpenid: '',
        loginTime: null,
        loginNum: null,
        loginDevice: '',
        province: '',
        city: '',
        area: '',
        longitude: '',
        latitude: '',
        vAuth: '',
        memberType: '',
        privateLetterNum: null,
        acceptNum: null,
        memberStartTime: null,
        memberEndTime: null,
        warningsNum: null,
        currencyNum: null,
        memberSts: null,
        createTime: null,
        memberNo: '',
        source: '',
        memberInfo: null,
        marriage: '',
        height: '',
        weight: '',
        homeTop: null,
        idNo: '',
        nativePlace: '',
        displaySts: 0,
        noRegsterHomeIndex: 0,
        updateDedicatedToMembershipApi: 0
      },
      sexs: [],
      marriages: [],
      educations: [],
      zodiacs: [],
      constellations: [],
      nations: [],
      politicalOutlooks: [],
      memberRankingAtHomes: [],
      memberOccupations: [],
      memberIndustrys: [],
      memberCompanyTypes: [],
      memberPosts: [],
      memberPostTypes: [],
      memberAnnualIncomes: [],
      memberSmokes: [],
      memberDrinks: [],
      carPurchases: [],
      buyHouses: [],
      pics: []
    };
  },
  methods: {
    updateDedicatedToMembershipApi: function updateDedicatedToMembershipApi(top) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var pro;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (top === 0) {
                top = 1;
              } else {
                top = 0;
              }
              pro = {
                memberId: _this.form.memberId,
                dedicatedToMembership: top
              };
              _this.form.dedicatedToMembership = top;
              _context.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.fileList.push(file);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    closeMemberLink: function closeMemberLink() {
      this.memberLinkDialogVisible = false;
    },
    resetMemberLink: function resetMemberLink() {
      var par = [this.form.memberId];
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.memberLinkDialogVisible = true;
      this.$refs.memberLink.setTitle('关联账号');
      this.$refs.memberLink.initData(par);
    },
    ifPicUrl: function ifPicUrl(url) {
      if (url.indexOf('http') !== -1) {
        return url;
      }
      return this.downloadUrl + url;
    },
    permanentFreeze: function permanentFreeze() {
      var _this2 = this;
      this.$confirm('确定要永久冻结会员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.updateFreeze();
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消冻结'
        });
      });
    },
    freezeRecordsInitData: function freezeRecordsInitData() {
      this.$emit('initTableData');
    },
    freezeRecordsOpen: function freezeRecordsOpen() {
      this.$refs.memberFreezeRecords.setTitle('冻结');
      this.$refs.memberFreezeRecords.setData(this.form);
      this.freezeRecordsDialogVisible = true;
    },
    freezeRecordsOpen2: function freezeRecordsOpen2() {
      this.$refs.memberFreezeRecords.setTitle('冻结');
      this.$refs.memberFreezeRecords.setData2(this.form);
      this.freezeRecordsDialogVisible = true;
    },
    freezeRecordsClose: function freezeRecordsClose() {
      this.freezeRecordsDialogVisible = false;
    },
    updateFreeze: function updateFreeze() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var pro;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              pro = {
                memberId: _this3.form.memberId,
                type: 2,
                remarks: '永久冻结'
              };
              _context2.n = 1;
              return api.SAVE_MEMBERFREEZERECORDS(pro);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    editMemberInfoDataInitData: function editMemberInfoDataInitData() {
      this.$emit('initTableData');
    },
    editMemberInfoOpen: function editMemberInfoOpen() {
      this.$refs.selectMemberPushMessages.setTitle('推送记录');
      this.$refs.selectMemberPushMessages.initTableData(this.form);
      this.editMemberInfoDialogVisible = true;
    },
    editMemberInfoClose: function editMemberInfoClose() {
      this.editMemberInfoDialogVisible = false;
    },
    selectDataInitData: function selectDataInitData() {
      this.$emit('initTableData');
    },
    selectDataOpen: function selectDataOpen() {
      this.$refs.selectData.setTitle('用户数据');
      this.$refs.selectData.getMemberDatas(this.form);
      this.selectDataDialogVisible = true;
    },
    selectDataClose: function selectDataClose() {
      this.selectDataDialogVisible = false;
    },
    editVauInitData: function editVauInitData() {
      this.$emit('initTableData');
    },
    editVauOpen: function editVauOpen() {
      this.$refs.editVau.setTitle('加V认证');
      this.$refs.editVau.setData(this.form);
      this.editVauDialogVisible = true;
    },
    editVauClose: function editVauClose() {
      this.editVauDialogVisible = false;
    },
    editBirthdayInitData: function editBirthdayInitData(time) {
      this.form.birthday = time;
      this.$emit('initTableData');
    },
    editBirthdayOpen: function editBirthdayOpen() {
      this.$refs.editBirthday.setTitle('修改出生日期');
      this.$refs.editBirthday.setData(this.form);
      this.editBirthdayDialogVisible = true;
    },
    editBirthdayClose: function editBirthdayClose() {
      this.editBirthdayDialogVisible = false;
    },
    editSexInitData: function editSexInitData(sex) {
      // this.form.sex = this.enums.checkEnumsValue(this.sexs, sex, '')
      this.form.sex = sex;
      this.$emit('initTableData');
    },
    editSexOpen: function editSexOpen() {
      this.$refs.editSex.setTitle('修改性别');
      this.$refs.editSex.setData(this.form);
      this.editSexDialogVisible = true;
    },
    editSexClose: function editSexClose() {
      this.editSexDialogVisible = false;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: name
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this4.enumList = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.memberId = null;
      this.form.nickName = null;
      this.form.sex = null;
      this.form.name = null;
      this.form.headUrl = null;
      this.form.phone = null;
      this.form.userName = null;
      this.form.passWord = null;
      this.form.wxMiniOpenid = null;
      this.form.loginTime = null;
      this.form.loginNum = null;
      this.form.loginDevice = null;
      this.form.province = null;
      this.form.city = null;
      this.form.area = null;
      this.form.longitude = null;
      this.form.latitude = null;
      this.form.vAuth = null;
      this.form.memberType = null;
      this.form.privateLetterNum = null;
      this.form.acceptNum = null;
      this.form.memberStartTime = null;
      this.form.memberEndTime = null;
      this.form.warningsNum = null;
      this.form.currencyNum = null;
      this.form.memberSts = null;
      this.form.createTime = null;
      this.form.memberNo = null;
      this.form.source = null;
      this.form.memberInfo = null;
      this.form.homeTop = 0;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.getEnumsApi();
      this.form = {};
      this.getMemberInfoApi(data.memberId, data);
    },
    getEnumsApi: function getEnumsApi() {
      var thiz = this;
      this.enums.sexEnums(function (arg) {
        thiz.sexs = arg.body;
      });
      this.enums.getMbmberMarriages(function (arg) {
        thiz.marriages = arg.body;
      });
      this.enums.getEducations(function (arg) {
        thiz.educations = arg.body;
      });
      this.enums.getZodiacs(function (arg) {
        thiz.zodiacs = arg.body;
      });
      this.enums.getConstellations(function (arg) {
        thiz.constellations = arg.body;
      });
      this.enums.getNations(function (arg) {
        thiz.nations = arg.body;
      });
      thiz.enums.getMemberPoliticalOutlooks(function (arg) {
        thiz.politicalOutlooks = arg.body;
      });
      this.enums.getMemberRankingAtHomes(function (arg) {
        thiz.memberRankingAtHomes = arg.body;
      });
      this.enums.getMemberOccupations(function (arg) {
        thiz.memberOccupations = arg.body;
      });
      this.enums.getMemberIndustrys(function (arg) {
        thiz.memberIndustrys = arg.body;
      });
      this.enums.getMemberCompanyTypes(function (arg) {
        thiz.memberCompanyTypes = arg.body;
      });
      this.enums.getMemberPosts(function (arg) {
        thiz.memberPosts = arg.body;
      });
      this.enums.getMemberPostTypes(function (arg) {
        thiz.memberPostTypes = arg.body;
      });
      this.enums.getMemberAnnualIncomes(function (arg) {
        thiz.memberAnnualIncomes = arg.body;
      });
      this.enums.getMemberSmokes(function (arg) {
        thiz.memberSmokes = arg.body;
      });
      this.enums.getMemberDrinks(function (arg) {
        thiz.memberDrinks = arg.body;
      });
      this.enums.getBuyHouse(function (arg) {
        thiz.buyHouses = arg.body;
      });
      this.enums.getCarPurchase(function (arg) {
        thiz.carPurchases = arg.body;
      });
    },
    getMemberInfoApi: function getMemberInfoApi(memberId, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var pro, ls, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              pro = {
                memberId: memberId
              };
              ls = _objectSpread({}, data);
              _context4.n = 1;
              return api.GET_MEMBERINFO_INFO(pro);
            case 1:
              res = _context4.v;
              _this5.fileList = [];
              _this5.getPicsApi(memberId);
              res.body.height = res.body.height + 'cm';
              res.body.weight = res.body.weight + 'kg';
              res.body.nation = _this5.enums.checkEnumsValue(_this5.nations, res.body.nation, '');
              res.body.constellation = _this5.enums.checkEnumsValue(_this5.constellations, res.body.constellation, '');
              res.body.politicalOutlook = _this5.enums.checkEnumsValue(_this5.politicalOutlooks, res.body.politicalOutlook, '');
              res.body.rankingAtHome = _this5.enums.checkEnumsValue(_this5.memberRankingAtHomes, res.body.rankingAtHome, '');
              // res.body.occupation = this.enums.checkEnumsValue(this.memberOccupations, res.body.occupation, '')
              res.body.industry = _this5.enums.checkEnumsValue(_this5.memberIndustrys, res.body.industry, '');
              res.body.companyType = _this5.enums.checkEnumsValue(_this5.memberCompanyTypes, res.body.companyType, '');
              res.body.postNature = _this5.enums.checkEnumsValue(_this5.memberPostTypes, res.body.postNature, '');
              res.body.post = _this5.enums.checkEnumsValue(_this5.memberPosts, res.body.post, '');
              res.body.annualIncome = _this5.enums.checkEnumsValue(_this5.memberAnnualIncomes, res.body.annualIncome, '');
              res.body.smoke = _this5.enums.checkEnumsValue(_this5.memberSmokes, res.body.smoke, '');
              res.body.drink = _this5.enums.checkEnumsValue(_this5.memberDrinks, res.body.drink, '');
              console.log(ls.carPurchase);
              console.log(ls.buyHouse);
              // ls.carPurchase = this.enums.checkEnumsValue(this.carPurchases, ls.carPurchase, '')
              // ls.buyHouse = this.enums.checkEnumsValue(this.buyHouses, ls.buyHouse, '')
              ls.city = JSON.stringify(ls.memberCitys);
              // ls.sex = this.enums.checkEnumsValue(this.sexs, ls.sex, '')
              // ls.marriage = this.enums.checkEnumsValue(this.marriages, ls.marriage, '')
              // ls.education = this.enums.checkEnumsValue(this.educations, ls.education, '')
              // res.body.zodiac = this.enums.checkEnumsValue(this.zodiacs, res.body.zodiac, '')
              _this5.form = Object.assign(ls, res.body);
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteMember: function deleteMember() {
      var _this6 = this;
      this.$confirm('确定要删除会员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.deleteMemberApi();
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteMemberApi: function deleteMemberApi() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var pro;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              pro = {
                memberId: _this7.form.memberId
              };
              _context5.n = 1;
              return api.DELETE_MEMBER(pro);
            case 1:
              _this7.$message.success('操作成功');
              _this7.handleClose();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getPicsApi: function getPicsApi(memberId) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var pro, res, fileList, i, file;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              pro = {
                memberId: memberId
              };
              _context6.n = 1;
              return api.GET_MEMBERPICTURES_LIST(pro);
            case 1:
              res = _context6.v;
              _this8.pics = res.body;
              fileList = [];
              for (i = 0; i < _this8.pics.length; i++) {
                file = {
                  name: '1111',
                  url: _this8.ifPicUrl(_this8.pics[i])
                };
                fileList.push(file);
              }
              _this8.fileList = fileList;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    updateHomeTopApi: function updateHomeTopApi(top) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var pro;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (top === 0) {
                top = 1;
              } else {
                top = 0;
              }
              pro = {
                memberId: _this9.form.memberId,
                noRegsterHandIndex: top
              };
              _this9.form.noRegsterHandIndex = top;
              _context7.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              _this9.$emit('initTableData');
              _this9.$message.success('操作成功');
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    updateHomeTopApi2: function updateHomeTopApi2(top) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var pro;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (top === 0) {
                top = 1;
              } else {
                top = 0;
              }
              pro = {
                memberId: _this0.form.memberId,
                bandIndexTopSts: top
              };
              _this0.form.bandIndexTopSts = top;
              _context8.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              _this0.$emit('initTableData');
              _this0.$message.success('操作成功');
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    /**
     * 隐藏 - 取消隐藏
     * @returns {Promise<void>}
     */
    updateMemberDisplaySts: function updateMemberDisplaySts() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var pro;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              pro = {
                memberId: _this1.form.memberId,
                handDisplaySts: _this1.form.handDisplaySts === 0 ? 1 : 0
              };
              _this1.form.handDisplaySts = _this1.form.handDisplaySts === 0 ? 1 : 0;
              _context9.n = 1;
              return api.UPDATE_MEMBER_DISPLAY(pro);
            case 1:
              _this1.$message.success('操作成功');
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    updateApi: function updateApi() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return api.UPDATE_MEMBER(_this10.form);
            case 1:
              _this10.$emit('initTableData');
              _this10.$message.success('操作成功');
              _this10.handleClose();
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    saveApi: function saveApi() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return api.SAVE_MEMBER(_this11.form);
            case 1:
              _this11.$emit('initTableData');
              _this11.$message.success('操作成功');
              _this11.handleClose();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    save: function save() {
      var _this12 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this12.form.memberId != null) {
            _this12.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this12.updateApi();
            }).catch(function () {
              _this12.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this12.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};